import { SiteCoreDictionary } from './types';

const fallbackDictionary: SiteCoreDictionary = {
    hardBlockConfirm: 'Se over og bekreft',
    hardBlockConfirmNoNewCardOrder: 'Kort oppsummert',
    hardBlockConfirmDamagedCard: 'Bekreft fornyelse av skadet/ødelagt kort',
    hardBlockConfirmInfoText1: 'Kortnummer {}',
    hardBlockConfirmInfoText2part1: 'Nytt bankkort til',
    hardBlockConfirmInfoText2part2: 'blir bestilt, eksisterende kort',
    hardBlockConfirmInfoText2part3: 'blir sperret.',
    hardBlockRenewalConfirmInfoText2part3: 'blir sperret etter 45 dager.',
    confirmWarningContactInfo: 'Pass på at kontaktinformasjonen er riktig. Er den feil må du ta kontakt med banken.',
    orderCardAddressWhenAddressPassedText: 'Kortet vil bli sendt til din folkeregistrerte postadresse: ',
    hardBlockConfirmInfoText2Renew:
        'Nytt bankkort til {} blir bestilt, eksisterende kort {} blir slettet automatisk etter 45 dager.',
    hardBlockConfirmInfoNoReorder: 'Nytt kort er ikke bestilt.',
    blockStatusHard: 'Kortet er permanent sperret',
    blockStatusReordered: 'Kortet er sperret, og nytt kort er bestilt.',
    blockStatusReorderedSuffix: 'og rebestilt',
    chosenChangePinText: 'Du har valgt å endre PIN-kode.',
    chosenNotChangePinText: 'Du har valgt å beholde PIN-kode.',
    orderCardStep0Description: 'Normalt sett vil du motta nytt kort innen en ukes tid.',
    orderCardErrorBlockCardSuccess:
        'Kortet er sperret, men noe gikk galt med bestillingen av et nytt kort. Ta kontakt med banken din for å fullføre bestillingen.',
    messageErrorUps: 'Ojsann!',
    orderBankCardFailureText: 'Noe gikk feil, vent litt og prøv igjen.',
    genericErrorHeader: 'Vi beklager',
    blockError: 'Noe gikk galt. Vennligst prøv på nytt eller kontakt banken din',
    blockAreYouSureBlock: 'Sperr kort',
    blockAreYouSureReorder: 'Bestill nytt kort',
    blockAreYouSureRenew: 'Ja, forny kortet',
    confirmBySmsText: 'Bekreftelse blir sendt på SMS til mobilnummer',
    confirmBySmsText2: 'Vi har sendt en SMS-bekreftelse til mobilnummer',
    blockConfirmToAccountNumber: 'til kontonummer',
    formCancel: 'Avbryt',
    formOk: 'Ok',
    contactUsText: 'Kontakt oss',
    goBackText: 'Til forsiden',
    goBackToCards: 'Gå tilbake til Kort',
    orderBankCardSuccessText: 'Nytt kort er bestilt',
    noOrderBankCardSuccessText: 'Kortet er sperret',
    processFailedTitle: 'Det har oppstått en feil',
    blockPriceListLink: 'Se prisliste for kort',
    blockFailedDescription:
        'Vi fikk ikke sperret kortet ditt og kan derfor ikke bestille nytt kort. Prøv å sperre kortet igjen eller kontakt banken. ',
    reorderFailedDescription: 'Vi kunne ikke bestille nytt kort. Prøv å bestille kortet igjen eller kontakt banken. ',
    hardBlockConfirmInfoNoReorderText1: 'Kort til',
    hardBlockConfirmInfoNoReorderText2: 'blir sperret og det blir ikke bestilt nytt kort.',
    hardBlockRenewalWarning: 'Vær oppmerksom på at kortet du erstatter blir sperret etter  45 dager.',
};

export default fallbackDictionary;
